import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import { isEllipsisActive } from "utils/utils";
import { AlarmPageStrings, landingPageStrings, primaryMenuString } from "constants/constantStrings";
import SYSTEM_STATUS from "constants/systemStatus";

import BadgeLabel from "components/BadgeLabel";
import { DupontTooltip } from "components/DupontTooltip";
import StatusIndicator from "components/StatusIndicator";
import TextAnimation from "components/TextAnimation/TextAnimation";

import "./SystemCard.scss";

const SystemCard = ({ system, activeAlarms }) => {
  const [systemStatusText, setSystemStatusText] = useState("");
  const [systemNameEllipse, setSystemNameEllipse] = useState(false);
  const systemNameRef = useRef(null);

  const tagsToShowOnSysCard = ["recovery", "production", "conductivity"];

  useEffect(() => {
    if (system.connectionStatus === SYSTEM_STATUS.STATUS_ONLINE) {
      if (system.systemStatus === SYSTEM_STATUS.STATUS_STOPPED) {
        setSystemStatusText("Online/Idle");
      } else if (system.systemStatus === SYSTEM_STATUS.STATUS_RUNNING) {
        setSystemStatusText("Online/Running");
      } else if (system.systemStatus === SYSTEM_STATUS.STATUS_ALARM) {
        setSystemStatusText("Online/Alarming");
      }
    } else if (system.connectionStatus === SYSTEM_STATUS.STATUS_OFFLINE) {
      setSystemStatusText("Offline");
    } else {
      setSystemStatusText("Offline");
    }
  }, [system.connectionStatus, system.systemStatus]);

  function getActiveAlarms() {
    if (typeof activeAlarms !== "undefined") {
      const alarms = activeAlarms.filter(alarm => system.sysId === alarm.sysId);
      return alarms.length;
    }
  }
  useLayoutEffect(() => {
    setSystemNameEllipse(isEllipsisActive(systemNameRef));
  }, [systemNameRef?.current?.scrollWidth]);

  const getSystemInfo = infoType => {
    const { unit, value } = system[infoType];
    const tagNamewithUnit = landingPageStrings[infoType].replace("%", unit);
    return (
      <div className="flex-column calculatedValueText" key={infoType}>
        {system.connectionStatus === SYSTEM_STATUS.STATUS_ONLINE ? <TextAnimation text={value} /> : <>-</>}
        <span className="descriptionText" dangerouslySetInnerHTML={{ __html: tagNamewithUnit }} />
      </div>
    );
  };

  return (
    <div className="cardContainer insight-card customSystemCard">
      <div>
        <div className="d-flex">
          {systemStatusText !== "" && (
            <div className="system-status--indicator">
              <img className="sysImgSize" src={require("../../assets/SystemsAndAlarms/CCRO_gray.png")} alt="system" />
              <div className="status-icon-container">
                <StatusIndicator systemID={system.sysId} />
              </div>
            </div>
          )}
          <div className="system-name-width">
            <DupontTooltip title={system.systemName} placement="bottom-start" type={systemNameEllipse ? "primary" : "none"}>
              <span className="overflow cardTitle" ref={systemNameRef}>
                {system.systemName}
              </span>
            </DupontTooltip>
            <div className="descriptionText">{systemStatusText}</div>
            {system.activeInsights && (
              <BadgeLabel
                customClass="text_blue marginTop5"
                badgeDescription=""
                badgeText={system.activeInsights + " " + primaryMenuString.smartInsights}
              />
            )}
            {getActiveAlarms() > 0 ? (
              <BadgeLabel customClass="text_red marginTop5" badgeDescription="" badgeText={getActiveAlarms() + " " + AlarmPageStrings.activeAlarm} />
            ) : null}
          </div>
        </div>
        <div className="flex-between marginTop10">{tagsToShowOnSysCard.map(item => getSystemInfo(item))}</div>
      </div>
    </div>
  );
};

export default SystemCard;
